export const MODE_SELECTING = 'selecting';
export const MODE_DRAWING = 'drawing';
export const MODE_ERASING = 'erasing';
export const MODE_LINE = 'line';
export const MODE_RECTANGLE = 'rectangle';
export const MODE_CIRCLE = 'circle';
export const MODE_TEXT = 'text';
export const MODE_IMAGE = 'image';
